import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { i18nMessageService } from '../service/i18n-message-service'
import { from } from 'rxjs'
import { mergeMap, toArray, tap } from 'rxjs/operators'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'ko',
  silentFallbackWarn: process.env.NODE_ENV === 'production'
})

from(require('./json/messages.json$').messages)
  .pipe(
    tap(message => i18n.setLocaleMessage(message.lang, message.messages)),
    toArray(),
    mergeMap(x => i18nMessageService.getMessages$().pipe(mergeMap(messages => from(messages))))
  )
  .subscribe(message => {
    i18n.setLocaleMessage(message.lang, message.messages)
  })

export default i18n
